import FieldDropdown from "../../../generic/dropdown/dropdown"

import FieldConfig from "../../../proto/field-config"
import {GoalTypeOptions} from "../../../../model2/goal/const"
import FieldGoalType_FormValueEmpty from "./components/form/value-empty"
import FieldGoalType_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldGoalType_ValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldGoalType_PopoverMenu from "./components/popover/popover-menu"
import FieldGoalType_GoalListView from "./render/goal-list-view"
import FieldGoalType_GoalListEditable from "./render/goal-list-editable";
import FieldGoalType_View from "./render/view"

export default class FieldGoalType extends FieldDropdown {

    constructor(config: FieldConfig) {
        super(config)

        this.typeLabel                          = "Goal type"

        this.options                            = GoalTypeOptions
        this.noValueOption                      = false
        this.showMenuMore                       = false

        this.components.PopoverMenu             = FieldGoalType_PopoverMenu
        this.components.PopoverMenuMore         = null                              // menu bottom more area
        this.components.FormValueEmpty          = FieldGoalType_FormValueEmpty
        this.components.FormValueNotEmpty       = FieldGoalType_FormValueNotEmpty
        this.components.InlineValueNotEmpty     = FieldGoalType_ValueNotEmpty

        this.renderComponents.goalListEditable  = FieldGoalType_GoalListEditable
        this.renderComponents.goalListView      = FieldGoalType_GoalListView
        this.renderComponents.view              = FieldGoalType_View
    }

    getOptionsForEdit(model:any):any[] {
        return _.filter(this.getOptions(), option=>!option.hideInTypeSelector)
    }
}
